import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import toast, { Toaster } from 'react-hot-toast';

import { Container } from './styles';

export default function ContactForm() {
  const name = '';
  const email = '';
  const message = '';

  // const [name, setName] = useState('');
  // const [email, setEmail] = useState('');
  // const [message, setMessage] = useState('');

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('The name is required'),
    email: Yup.string()
      .email('Invalid format')
      .required('The e-mail is required'),
    message: Yup.string().required('The message is required'),
  });

  function sendEmail(templateId, variables) {
    window.emailjs
      .send('gmail', templateId, variables)
      .then((res) => {
        toast.success('Email successfully sent!', {
          position: 'top-right'
        });
      })
      .catch((err) => {
        toast.error(`The error that occured: ${err}`, {
            position: 'top-right'
          });
        });
  }

  const onSubmitValues = async (values, { setSubmitting }) => {
    const templateId = 'template_AoVhq1Ps';

    await sendEmail(templateId, {
      message_html: values.message,
      from_name: values.name,
      reply_to: values.email,
    });

    setSubmitting(false);

    values.name = '';
    values.email = '';
    values.message = '';
  };

  return (
    <Container>
      <h1>Get in Touch</h1>
      <Formik
        initialValues={{ name, email, message }}
        onSubmit={onSubmitValues}
        validationSchema={validationSchema}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            // dirty,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            // handleReset,
          } = props;
          return (
            <form onSubmit={handleSubmit}>
              <input
                id='name'
                placeholder='Your name'
                type='text'
                autoComplete='off'
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.name && touched.name
                    ? 'text-input error'
                    : 'text-input'
                }
              />
              {errors.name && touched.name && (
                <div className='input-feedback'>{errors.name}</div>
              )}
              <div style={{ margin: '8px 0' }} />

              <input
                id='email'
                placeholder='E-mail'
                type='text'
                autoComplete='off'
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.email && touched.email
                    ? 'text-input error'
                    : 'text-input'
                }
              />
              {errors.email && touched.email && (
                <div className='input-feedback'>{errors.email}</div>
              )}
              <div style={{ margin: '8px 0' }} />

              <textarea
                id='message'
                placeholder='Message'
                value={values.message}
                autosize={{ minRows: 2, maxRows: 6 }}
                onChange={handleChange}
                onBlur={handleBlur}
                className={
                  errors.message && touched.message
                    ? 'text-input error'
                    : 'text-input'
                }
              />
              {errors.message && touched.message && (
                <div className='input-feedback'>{errors.message}</div>
              )}
              <div style={{ margin: '8px 0' }} />

              <button type='submit' className='send' disabled={isSubmitting}>
                SEND
              </button>

              {/* <button
                  type="button"
                  className="outline"
                  onClick={handleReset}
                  disabled={!dirty || isSubmitting}
                >
                  RESET
                </button> */}
            </form>
          );
        }}
      </Formik>
      <Toaster />
    </Container>
  );
}
